<template>
  <div class="lottery-wrapper" v-if="isshow">
    <div class="join_lottery">
      <div class="lottery_box">
        <p class="lottery_btn">
          <span @click="create_lottery">创建抽奖</span>
          <span @click="export_list">导出中奖名单</span>
        </p>
        <div class="lottery_list" v-for="(i, index) in datalist" :key=index>
          <div class="lottery_name">
            <p>
              <span class="lottery_status" v-if="i.drawStatus == 200">未开始</span><span class="lottery_status" v-else-if="i.drawStatus == 300">抽奖中</span>
              <span class="been_drawn" v-else-if="i.drawStatus == 100">已开奖</span>
              <span v-if="i.joinMethod == 1">直播间全体学员自动参与抽奖</span><span v-else-if="i.joinMethod == 2">学员手动参与抽奖</span>
            </p>
            <p v-if="i.drawStatus == 200">
              <span class="cancel_lottery" @click="edit_lottery(i.id)">编辑</span><span class="cancel_lottery" @click="dialog_show(i.id, 2)">删除</span>
              <span class="open_lottery" @click="start_draw(i.id, index, i.drawPrizes[0].couponIdList)">发起抽奖</span>
            </p>
            <p v-if="i.drawStatus == 300">
              <span class="cancel_lottery" @click="dialog_show(i.id, 1)">终止抽奖</span><span v-if="i.drawCountdownSecond == 0" class="open_lottery" @click="draw_prize(i.id)">开奖</span>
              <span v-else class="open_lottery open_lotterys"><countdown :remainTime='i.remainingSeconds' :id='i.id'></countdown>后开奖</span>
            </p>
            <p v-if="i.drawStatus == 100"><span class="open_lottery win_prize" @click="look_namelist(i.id)">查看中奖名单</span></p>
          </div>
          <div class="lottery_detail" v-for="(item, idx) in i.drawPrizes" :key=idx>
            <p class="activity_info">{{item.newName}}：{{item.name}} x {{item.num}}份</p>
            <div class="coupon_prize">奖品：<span v-for="(j, key) in item.prizeType" :key=key>
              <span v-if="j == 1">商品ID<span v-for='(x, k) in item.goodsIdList' :key=k>{{[+x]}}</span></span>
              <span v-if="j == 2">货品编码<span v-for='(x, k) in item.cargoCodeList' :key=k>{{[x.cargo]}}</span></span>
              <span v-if="j == 3">优惠券ID<span v-for='(x, k) in item.couponIdList' :key=k>{{[x]}}</span></span><span v-if="j == 4">讲义邮寄</span><span v-if="j == 5">其他</span>
            </span><p class="errText">{{i.errText}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      width="30%">
      <span>确认终止抽奖吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel_close" @click="dialogVisible = false">取 消</el-button>
        <el-button class="cancel_sure" @click="cancel_lottery(cancel_id)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :show-close="false"
      :visible.sync="dialogsVisible"
      width="30%">
      <span>确认删除该抽奖活动吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel_close" @click="dialogsVisible = false">取 消</el-button>
        <el-button class="cancel_sure" @click="delete_prize(cancel_id)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import {global} from '../../common/api/api.config'
import { Toast } from 'mint-ui'
import countdown from 'components/offcn-teacher-lottery/countdown'

export default {
  data () {
    return {
      isshow: true,
      roomId: this.$route.query.roomid,
      ssoId: '',
      datalist: [],
      dialogVisible: false,
      dialogsVisible: false,
      cancel_id: '',
      level: ['一', '二', '三', '四', '五']
    }
  },
  mounted () {
    this.get_list()
    this.ssoId = window.sessionStorage.getItem('s')
  },
  components: {
    countdown
  },
  methods: {
    // 抽奖列表
    get_list () {
      this.$api.LIVEDRAWLIST({
        roomId: this.roomId,
        drawStatus: 0
      }).then(res => {
        if (res.code === 0) {
          this.datalist = res.data.list
          console.log(this.datalist)
        }
      }, err => {
        console.log(err)
      })
    },
    // 创建抽奖
    create_lottery () {
      this.$router.push({path: 'establish', query: {roomid: this.roomId}})
    },
    // 编辑抽奖
    edit_lottery (id) {
      this.$router.push({path: 'establish', query: {roomid: this.roomId, id: id}})
    },
    // 终止开奖
    dialog_show (id, type) {
      if (type === 1) {
        this.dialogVisible = true
      } else {
        this.dialogsVisible = true
      }
      this.cancel_id = id
    },
    cancel_lottery (id) {
      this.dialogVisible = false
      this.$api.DRAWSTOP({
        id: id,
        adminSsoId: this.ssoId
      }).then(res => {
        Toast({
          message: '抽奖已终止',
          className: 'offcn-toast'
        })
        setTimeout(function () {
          window.location.reload()
        }, 100)
        if (!webAccessor) return // eslint-disable-line
        webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
          path: 'end_lottery',
          data: {
            dataInfo: {id: id},
            roomId: this.roomId
          }
        }))
      }, err => {
        console.log(err)
      })
    },
    // 开奖
    draw_prize (id) {
      this.$api.DRAWEXEC({
        id: id,
        adminSsoId: this.ssoId
      }).then(res => {
        if (res.code === 0) {
          Toast({
            message: '开奖成功',
            className: 'offcn-toast'
          })
          let that = this
          setTimeout(function () {
            that.$router.push({path: 'winlist', query: {id: id}})
          }, 100)
          if (!webAccessor) return // eslint-disable-line
          webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
            path: 'run_lottery',
            data: {
              dataInfo: {id: id},
              roomId: this.roomId
            }
          }))
        } else {
          Toast({
            message: '开奖失败：' + res.msg,
            className: 'offcn-toast'
          })
          // setTimeout(function () {
          //   window.location.reload()
          // }, 2000)

          // if (!webAccessor) return // eslint-disable-line
          // webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
          //   path: 'end_lottery',
          //   data: {
          //     dataInfo: {id: id},
          //     roomId: this.roomId
          //   }
          // }))
        }
      }, err => {
        console.log(err)
      })
    },
    // 发起抽奖
    start_draw (id, idx, couponlist) {
      this.$api.COUPONINFO({
        ids: couponlist
      }).then(res => {
        if (res.code === 0) {
          console.log(res.data[couponlist])
          if (res.data[couponlist]) {
            let start = new Date(res.data[couponlist].validStartTime).getTime() / 1000
            let end = new Date(res.data[couponlist].validEndTime).getTime() / 1000
            if (res.data[couponlist].status !== 2 || res.data[couponlist].issueStatus === 2 || (res.data[couponlist].validTimeType === 1 && (parseInt(new Date().getTime() / 1000) < start || parseInt(new Date().getTime() / 1000) > end))) {
              this.$set(this.datalist[idx], 'errText', '发起失败，原因：优惠券ID[' + couponlist + ']已失效；')
              return false
            }
            if (res.data[couponlist].unReceiveNum === 0) {
              this.$set(this.datalist[idx], 'errText', '发起失败，原因：优惠券ID[' + couponlist + ']剩余可领取份数小于奖品份数;')
              return false
            }
            this.$api.DRAWSTART({
              id: id,
              adminSsoId: this.ssoId
            }).then(res => {
              if (res.code === 0) {
                Toast({
                  message: '发起成功',
                  className: 'offcn-toast'
                })
                setTimeout(function () {
                  window.location.reload()
                }, 1000)
                this.$api.DRAWDETAIL({
                  id: id
                }).then(res => {
                  if (res.code === 0) {
                    if (!webAccessor) return // eslint-disable-line
                    webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                      path: 'start_lottery',
                      data: {
                        dataInfo: res.data.draw,
                        roomId: this.roomId
                      }
                    }))
                  }
                }, err => {
                  console.log(err)
                })
              } else {
                if (res.data.invalidCouponIds.length && res.data.invalidGoodsIds.length) {
                  this.$set(this.datalist[idx], 'errText', '发起失败，原因：商品ID[' + res.data.invalidGoodsIds + ']为非出售中商品；优惠券ID[' + res.data.invalidCouponIds + ']剩余可领取份数小于奖品份数；')
                } else if (res.data.invalidCouponIds.length) {
                  this.$set(this.datalist[idx], 'errText', '发起失败，原因：优惠券ID[' + res.data.invalidCouponIds + ']剩余可领取份数小于奖品份数；')
                } else {
                  this.$set(this.datalist[idx], 'errText', '发起失败，原因：商品ID[' + res.data.invalidGoodsIds + ']为非出售中商品；')
                }
              }
            }, err => {
              console.log(err)
            })
          } else {
            this.$api.DRAWSTART({
              id: id,
              adminSsoId: this.ssoId
            }).then(res => {
              if (res.code === 0) {
                Toast({
                  message: '发起成功',
                  className: 'offcn-toast'
                })
                setTimeout(function () {
                  window.location.reload()
                }, 1000)
                this.$api.DRAWDETAIL({
                  id: id
                }).then(res => {
                  if (res.code === 0) {
                    if (!webAccessor) return // eslint-disable-line
                    webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
                      path: 'start_lottery',
                      data: {
                        dataInfo: res.data.draw,
                        roomId: this.roomId
                      }
                    }))
                  }
                }, err => {
                  console.log(err)
                })
              } else {
                if (res.data.invalidCouponIds.length && res.data.invalidGoodsIds.length) {
                  this.$set(this.datalist[idx], 'errText', '发起失败，原因：商品ID[' + res.data.invalidGoodsIds + ']为非出售中商品；优惠券ID[' + res.data.invalidCouponIds + ']剩余可领取份数小于奖品份数；')
                } else if (res.data.invalidCouponIds.length) {
                  this.$set(this.datalist[idx], 'errText', '发起失败，原因：优惠券ID[' + res.data.invalidCouponIds + ']剩余可领取份数小于奖品份数；')
                } else {
                  this.$set(this.datalist[idx], 'errText', '发起失败，原因：商品ID[' + res.data.invalidGoodsIds + ']为非出售中商品；')
                }
              }
            }, err => {
              console.log(err)
            })
          }
        }
      }, err => {
        console.log(err)
      })
    },
    // 删除
    delete_prize (id) {
      this.dialogsVisible = false
      this.$api.DRAWDEL({
        id: id,
        adminSsoId: Number(this.ssoId)
      }).then(res => {
        if (res.code === 0) {
          Toast({
            message: '删除成功',
            className: 'offcn-toast'
          })
          setTimeout(function () {
            window.location.reload()
          }, 100)
        }
      }, err => {
        console.log(err)
      })
    },
    // 查看中奖名单
    look_namelist (id) {
      this.$router.push({path: 'winlist', query: {id: id}})
    },
    // 导出中奖名单
    export_list () {
      let SERVER_BASE_URL
      if (window.location.host === 'live.eoffcn.com') {
        SERVER_BASE_URL = global.mall_online_url
      } else {
        SERVER_BASE_URL = global.mall_test_url
      }
      let that = this
      sso.ready().then(function (user) { // eslint-disable-line
        axios({
          url: SERVER_BASE_URL + '/drawTeacher/exportRoomDrawResult',
          method: 'post',
          headers: user.getHeader(),
          responseType: 'arraybuffer',
          data: {
            roomId: that.$route.query.roomid
          }
        }).then((res) => {
          Toast({
            message: '导出成功',
            className: 'offcn-toast'
          })
          console.log(that.ab2str(res.data))
          // let blob = new Blob([res.data])
          // let href = window.URL.createObjectURL(blob)
          // let link = document.createElement('a') // 创建a标签
          // link.download = '中奖学员名单' + parseInt(new Date().getTime() / 1000) + '.xlsx'
          // link.style.display = 'none'
          // link.href = href
          // document.body.appendChild(link)
          // link.click() // 执行下载
          // window.URL.revokeObjectURL(href)
          // document.body.removeChild(link) // 释放标签
          if (!webAccessor) return // eslint-disable-line
          webAccessor.save(that.ab2str(res.data)) // eslint-disable-line
        })
      })
    },
    ab2str (buf) {
      return String.fromCharCode.apply(null, new Uint8Array(buf))
    }
  }
}
</script>

<style scoped lang="scss">
.cancel_sure {
  color: #ffffff;
  border: #fe895f;
  background: #fe895f;
}
.cancel_close:hover {
  color: #606266;
  border: 1px solid #DCDFE6;
  background: #ffffff;
}
.lottery-wrapper {
  p {
    margin: 0;
  }
  .join_lottery {
    background: #ffffff;
    .lottery_box {
      padding: 16px 24px;
    }
    .lottery_btn {
      display: flex;
      padding-bottom: 6px;
      span {
        width: 100px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        color: #ffffff;
        background: #fe895f;
        border-radius: 4px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .lottery_list {
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      margin-top: 10px;
    }
    .lottery_name {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      background: #fafafa;
      padding: 6px 20px;
      .lottery_status {
        color: #fe895f;
        margin-right: 10px;
      }
      .been_drawn {
        color: #949bab;
        margin-right: 10px;
      }
      .cancel_lottery{
        color: #e60012;
        margin-right: 16px;
        cursor: pointer;
      }
      .open_lottery {
        display: inline-block;
        width: 70px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #ffffff;
        background: #fe895f;
        border-radius: 4px;
        cursor: pointer;
      }
      .open_lotterys {
        width: 100px;
      }
      .win_prize {
        width: 100px;
      }
    }
    .lottery_detail {
      padding: 10px 20px;
      .activity_info {
        font-size: 14px;
        // color: #7d828d;
      }
      .coupon_prize {
        font-size: 12px;
        color: #949bab;
        margin-top: 8px;
        .errText {
          color: #e60012;
          margin-top: 10px;
        }
      }
    }
    .lottery_details {
      padding: 0 20px 10px;
      .activity_info {
        margin-top: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-lottery/list.vue